import { FormTemplate } from "components/modal/templates";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import React from "react";
import { editRefueling } from "sources/books/refueling";

const config = {
    requiredLoadVolumeForCar: {
        // field
        label: "Плановый объем заправки для машины",
        inputProps: { name: "requiredLoadVolumeForCar", type: "number", step: "0.1", min: 0 },
        required: true,
        fieldWrapper: "col-4",
        labelWrapper: "col-8 col-form-label col-form-label-sm",
        bWrapper: "row mb-1",
    },
    requiredLoadVolumeForTrailer: {
        // field
        label: "Плановый объем заправки для прицепа",
        inputProps: { name: "requiredLoadVolumeForTrailer", type: "number", step: "0.1", min: 0 },
        required: true,
        fieldWrapper: "col-4",
        labelWrapper: "col-8 col-form-label col-form-label-sm",
        bWrapper: "row mb-1",
    },
};

const initialState = getInitialStateFromConfig(config);

class EditPlanRefueling extends FormTemplate {
    sendRequest = (stateData) => {
        this.setState({ isLoading: true });
        const { refuelingId, bidId, carRequiredLoadVolume, trailerRequiredLoadVolume } = this.props;
        const reqVolumeForCar = stateData.requiredLoadVolumeForCar;
        const reqVolumeForTrailer = stateData.requiredLoadVolumeForTrailer;
        return editRefueling({
            id: refuelingId,
            bidId,
            requiredLoadVolumeForCar: carRequiredLoadVolume ? parseFloat(reqVolumeForCar) : null,
            requiredLoadVolumeForTrailer: trailerRequiredLoadVolume ? parseFloat(reqVolumeForTrailer) : null,
        });
    };

    renderBodyInner = () => {
        const {
            config: { requiredLoadVolumeForCar, requiredLoadVolumeForTrailer },
            carRequiredLoadVolume,
            trailerRequiredLoadVolume,
        } = this.props;
        if (carRequiredLoadVolume) {
            requiredLoadVolumeForCar.validators = [requiredField];
        }
        if (trailerRequiredLoadVolume) {
            requiredLoadVolumeForTrailer.validators = [requiredField];
        }
        return (
            <>
                {carRequiredLoadVolume && this.renderField(requiredLoadVolumeForCar)}
                {trailerRequiredLoadVolume && this.renderField(requiredLoadVolumeForTrailer)}
            </>
        );
    };

    renderActionSend = () => {
        const cname = "btn btn-brand btn-sm modal-window__footer-action";
        return <input type="submit" className={cname} value="Обновить" />;
    };
}

const ConfiguredModal = (props) => <EditPlanRefueling {...props} config={config} initialState={initialState} />;

export default ConfiguredModal;
